import cn from 'classnames'
import { FC, PropsWithChildren } from 'react'

import styles from './TopPartnersManagementCard.module.scss'

interface ITopPartnersManagementCardProps extends PropsWithChildren {
  className?: string
}

export const TopPartnersManagementCard: FC<ITopPartnersManagementCardProps> = ({
  className,
  children,
}) => <div className={cn(styles.root, className)}>{children}</div>
